import { useParams, Navigate } from 'react-router-dom';
import { captureReferral } from '../../lib/referral';

// Vanity referral path: app.medilink.vip/r/<code> — QR/print/deck friendly.
// Stores the code (first-touch, 30-day window) and lands on the signup page.
export default function RefRedirect() {
  const { code } = useParams();
  // Synchronous on purpose: the capture must happen before <Navigate> unmounts
  // us. Idempotent, so StrictMode's double-render is harmless.
  captureReferral(code);
  return <Navigate to="/register" replace />;
}
